<template>
	<dropdown-select
		v-if="selectedTab"
		class="variant-selector"
		:items="selectedTab.list"
		v-model="open"
		fullWidth
		slotLabel
	>
		<span slot="label">
			{{ dynamicLabel }}
			<template v-if="lowestPrice">
				från
				<span class="lowest-price"> {{ formatPrice(lowestPrice, currency) }}</span>
			</template>
		</span>
		<div class="variant-tab-wrap" slot="tabs" v-if="variantTabs.length > 1">
			<button
				v-for="(tab, index) in variantTabs"
				:class="['variant-tab toggle-btn', {'selected-tab': selectedTabIndex === index}]"
				:key="index"
				@click.stop="selectedTabIndex = index"
			>
				{{ tab.name }}
			</button>
			<modal
				v-if="product.energyMarking"
				v-model="energyMarkingModal"
				label-style="pointer-events: auto;"
				root-style="pointer-events: auto;">
				<energy-rating
					slot="label"
					class="ap-tl mt-3"
					:height="1.2"
					style="margin-left: -3px; pointer-events: all;"
					@click="energyMarkingModal = true;"
					:rating="product.energyMarking.rating"
					:scale="product.energyMarking.scale"
				/>
				<energy-datasheet :marking="product.energyMarking" />
			</modal>
		</div>
		<template slot-scope="row">
			<product-list-variant-item :product="row.item" :selected="product.id === row.item.id" />
		</template>
	</dropdown-select>
</template>
<script>
import { t } from 'datastore/i18n';
import { inStockAnywhere, formatPrice } from 'utils';

export default {
	props: {
		product: {
			type: Object,
			required: true,
		},
	},
	data () {
		return {
			open: false,
			selectedTabIndex: 0,
			energyMarkingModal: false,
		};
	},
	methods: {
		tp: t.prefix('PRODUCT'),
		/*
	 	 * Make sure list has atleast one product and is not the product the user is currently browsing.
		 */
		shouldShowTab (list) {
			return list.length > 1 || (list[0] && list[0].id !== this.product.id);
		},
		formatPrice,
	},
	computed: {
		/**
		 * A list of all normal variants (i.e. not fyndwares or discontinued variants).
		 */
		variants () {
			if (! this.product.variants) {
				return [];
			}

			return this.product.variants.list.filter((variant) => {
				return ! variant.isFyndware && (! variant.discontinued || (variant.discontinued && inStockAnywhere(variant.stock)));
			});
		},
		/**
		 * A list of all fyndwares.
		 */
		fyndwares () {
			if (! this.product.variants) {
				return [];
			}

			return this.product.variants.list.filter((variant) => {
				return variant.isFyndware && (variant.id === this.product.id || inStockAnywhere(variant.stock));
			});
		},
		variantTabs () {
			const tabs = [];
			if (this.shouldShowTab(this.variants)) {
				tabs.push({
					name: this.tp('VARIANTS'),
					list: this.variants,
				});
			}
			if (this.shouldShowTab(this.fyndwares)) {
				tabs.push({
					name: this.tp('FYNDWARES'),
					list: this.fyndwares,
				});
			}
			return tabs;
		},
		selectedTab () {
			return this.variantTabs[this.selectedTabIndex];
		},
		dynamicLabel () {
			let label = '';
			if (this.variantTabs.length === 1) {
				label = this.selectedTab.name;
			} else {
				label = this.variantTabs.map((element) => {
					return element.name;
				}).join(' / ');
			}

			return label;
		},
		lowestPrice () {
			let price = parseInt(this.product.price.price);

			/* Only checks if there is a lower price among fyndwares */
			if (this.fyndwares && ! this.product.isFyndware) {
				this.fyndwares.forEach((item) => {
					let fyndwarePrice = parseInt(item.price.price);

					/* Checks if each price is lower than main product or last lowest price in loop */
					if (price > fyndwarePrice) {
						price = fyndwarePrice;
					}
				});
			}

			/* If the new price is the same as the original one, return 0 to be read as 'false' */
			return price === parseInt(this.product.price.price) ? 0 : price;
		},
		currency () {
			return this.product.price.currency;
		}
	},
};
</script>
